import ApiClient from "../../ApiClient";

const ZOHO_CLIENT_ID = process.env.REACT_APP_ZOHO_CLIENT_ID;
const ZOHO_AUTH_URL = "https://accounts.zoho.com/oauth/v2/auth";
// Keeps the same path already registered as the redirect URI in Zoho's API
// console (previously served by the static zoho-oauth-callback.html) so this
// migration doesn't require re-registering the OAuth app per environment.
const ZOHO_REDIRECT_URI =
  process.env.REACT_APP_ZOHO_REDIRECT_URI ||
  `${window.location.origin}/zoho-oauth-callback.html`;
// The callback page always loads on this fixed origin, regardless of which
// tenant subdomain opened the popup, so message listeners must check the
// event against this origin rather than their own window.location.origin.
export const ZOHO_REDIRECT_ORIGIN = new URL(ZOHO_REDIRECT_URI).origin;
export { ZOHO_REDIRECT_URI };

const ZOHO_SCOPE =
  "ZohoMail.messages.READ,ZohoMail.messages.CREATE,ZohoMail.messages.UPDATE,ZohoMail.messages.DELETE,ZohoMail.accounts.READ,ZohoMail.folders.READ";

export const getZohoOAuthUrl = () => {
  if (!ZOHO_CLIENT_ID) throw new Error("Zoho OAuth client ID is not configured.");

  // `flow: "zoho"` tags this OAuth round-trip, matching the `{origin, flow}`
  // convention GoogleCallback.js uses for Meet/Gmail.
  const state = JSON.stringify({
    origin: window.location.origin,
    flow: "zoho",
  });

  return (
    `${ZOHO_AUTH_URL}` +
    `?response_type=code` +
    `&client_id=${ZOHO_CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(ZOHO_REDIRECT_URI)}` +
    `&scope=${encodeURIComponent(ZOHO_SCOPE)}` +
    `&access_type=offline` +
    `&prompt=consent` +
    `&state=${encodeURIComponent(state)}`
  );
};

// redirectUri must exactly match what was sent to the /auth endpoint above —
// defaults to the same fixed ZOHO_REDIRECT_URI so callers don't have to know it.
export async function connectZoho(code, redirectUri = ZOHO_REDIRECT_URI) {
  const resp = await ApiClient.post("/Email/oauth/zoho/connect", {
    code,
    redirectUri,
  });
  return resp.data.data;
}

export async function getZohoConnectionStatus() {
  const resp = await ApiClient.get("/Email/oauth/zoho/status");
  return resp.data.data;
}

export async function disconnectZoho() {
  const resp = await ApiClient.delete("/Email/oauth/zoho/disconnect");
  return resp.data.data;
}
